/**
 * Places with room in them.
 *
 * Not "hiding places" — nothing in here is for hiding, any more than a walk-in
 * is for hiding. These are the fixed things in the building with a person-sized
 * space under or inside them, and the concealment rule happens to be interested
 * in that. A table with a linen over it and a cart somebody parked are the same
 * kind of thing and are not in this file, because they are not fixed: they are
 * worked out from where they actually are at the time.
 *
 * Feet, like the rest of the level data. `radius` is how far from the point
 * still counts as being in it.
 *
 * Nothing in here is on the main service run and nothing in here ever will be.
 * A hundred and forty-four foot straight with no door in it is the most exposed
 * route on the property, and that is what it is *for* — it is the thing that
 * pays for being able to cross the building at twenty miles an hour. Put one
 * hollow halfway down it and the run stops being a decision. `level.test.js`
 * fails if one appears there.
 */
export const HOLLOWS = [
  { id: 'under-the-stage', at: [56, 97], radius: 10, label: 'under the stage' },
  { id: 'the-walk-in', at: [-22, -37], radius: 6, label: 'in the walk-in' },
  // The gap at the end of each air wall pocket in the Crown Ballroom, behind
  // the pocket door. Room for one person, standing.
  { id: 'airwall-east', at: [103.3, 53.5], radius: 2.2, label: 'in the air wall pocket' },
  { id: 'airwall-west', at: [8.7, 47.5], radius: 2.2, label: 'in the air wall pocket' },
];
